import {
    APP_VERSION,
    IS_EPG_CACHE_CHECKED,
    IS_TV_CACHE_CHECKED,
    LAST_TIME_CACHE_CLEARED,
    MILIS_10m,
} from '@/shared/constants'
import { useTVStore, useVODStore } from '@/shared/store'
import { useEffect } from 'react'
import {
    getFromLocalStorage,
    removeFromLocalStorage,
    saveToLocalStorage,
} from '@/shared/localStorage/localStorageRepository'
import { useEPGCache } from '@/shared/cache/hooks/useEPGCache'
import { useVodItems } from '@/features/VOD/hooks/useVodItems'
import packageJson from '../../../package.json'

export const useCacheAutoRefresh = () => {
    const { resetVodRows, setClearVod, isVodContentPlaying } = useVODStore()
    const { isTvPlaying, clearTvStore } = useTVStore()
    const { clearCache } = useEPGCache()
    const { setRowItems } = useVodItems('')
    const { appVersion } = packageJson

    useEffect(() => {
        if (isVodContentPlaying || isTvPlaying) return

        const clearCacheHandler = () => {
            if (isVodContentPlaying || isTvPlaying) return

            resetVodRows()
            clearCache()
            setRowItems([])
            clearTvStore()
            setClearVod()

            removeFromLocalStorage(IS_EPG_CACHE_CHECKED)
            removeFromLocalStorage(IS_TV_CACHE_CHECKED)
            removeFromLocalStorage(APP_VERSION)

            saveToLocalStorage(LAST_TIME_CACHE_CLEARED, `${Date.now()}`)
            saveToLocalStorage(APP_VERSION, appVersion)
        }

        const lastCleared = Number(getFromLocalStorage(LAST_TIME_CACHE_CLEARED))
        const lastAppVersion = getFromLocalStorage(APP_VERSION)

        const isCacheOld = lastCleared < Date.now() - MILIS_10m
        const isNewAppVersion = lastAppVersion !== appVersion

        const id = setInterval(clearCacheHandler, MILIS_10m)

        if (isCacheOld || isNewAppVersion) {
            clearCacheHandler()
            clearInterval(id)
        }

        return () => clearInterval(id)
    }, [isTvPlaying, isVodContentPlaying])
}
